const root = () => window.Shopify?.routes?.root || '/';

class QuickAdd extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-open]');
      if (opener) {
        const open = !this.classList.contains('is-open');
        document.querySelectorAll('quick-add.is-open').forEach((q) => q !== this && q.close());
        this.classList.toggle('is-open', open);
        opener.setAttribute('aria-expanded', open);
        return;
      }
      const pick = e.target.closest('[data-variant]');
      if (pick && !pick.disabled) this.add(pick);
    });
  }

  close() {
    this.classList.remove('is-open');
    this.querySelector('[data-open]')?.setAttribute('aria-expanded', 'false');
  }

  async add(btn) {
    this.classList.add('is-busy');
    try {
      const res = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +btn.dataset.variant, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error((await res.json()).description);
      const cart = await (await fetch(`${root()}cart.js`)).json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
      this.classList.add('is-done');
      setTimeout(() => this.classList.remove('is-done'), 1300);
      this.close();
    } catch (err) {
      console.warn('Quick add failed', err);
    } finally {
      this.classList.remove('is-busy');
    }
  }
}
customElements.define('quick-add', QuickAdd);

document.addEventListener('click', (e) => {
  if (!e.target.closest('quick-add')) document.querySelectorAll('quick-add.is-open').forEach((q) => q.close());
});
